<template>
  <nav class="navbar navbar-expand-lg navbar-dark">
    <div class="top-navbar">
      <div>
        <selector
          ref="shop_init"
          @input="setShop"
          :title="`Установите магазин`"
          :titleKey="`select_shop`"
          :prefix="`global`"
          :modal="`shop`"
          :params="{ user_id: $store.state.user.id }"
          :selectKey="`name`"
          :triggerOpen="
            !shop &&
            !$store.state.user.is_root &&
            !$store.state.user.organizations.length
          "
          v-model="shop"
        />
      </div>

      <button
        class="navbar-toggler navbar-burger"
        type="button"
        @click="toggleSidebar"
        :aria-expanded="$sidebar.showSidebar"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-bar"></span>
        <span class="navbar-toggler-bar"></span>
        <span class="navbar-toggler-bar"></span>
      </button>
    </div>
  </nav>
</template>
<script>
import { mapState } from "vuex";

export default {
  // watch: {
  //   shop: {
  //     handler: function (val) {
  //       if(!val){

  //       }
  //     },
  //     deep: true,
  //   },
  // },
  computed: {
    routeName() {
      const { path } = this.$route;
      if (this.routes[path]) {
        return this.routes[path]["title"];
      }
      return "";
    },
    ...mapState(["routes"]),
  },
  data() {
    return {
      activeNotifications: false,
      shop: null,
    };
  },
  mounted() {
    this.shop = this.$store.state.shop;
  },
  methods: {
    setShop(val) {
      if (val && val.id) {
        this.$store.dispatch("setShop", val);
        localStorage.setItem("shop", JSON.stringify(val));
        this.$http.defaults.headers.common["shop"] = val.id;
      } else {
        localStorage.setItem("shop", "");
        this.$store.dispatch("setShop", "");
        this.$http.defaults.headers.common["shop"] = "";
      }

      this.$store.dispatch("setLastUpdate", new Date());
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
  },
};
</script>
<style lang="scss">
.top-navbar {
  width: 100%;
  padding: 0 30px;

  @media (max-width: 768px) {
    padding: 0 15px;
  }

  display: flex;
  flex-wrap: wrap;

  & > div {
    padding-top: 7px;
    max-width: 300px !important;
    width: calc(100% - 40px) !important;
  }

  & > button {
    margin-left: auto;
    width: 40px;
  }
}
</style>
